import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useSelector } from 'react-redux';

import { useEntitlementsUpdates } from '~api/business-owner/queries/entitlements/useEntitlementsUpdates';
import { GlobalState } from '~reducers';
import { LDFlags } from '~types/featureFlags';

function EntitlementsSubscription({ businessId }: { businessId: number }): null {
	useEntitlementsUpdates(businessId);

	return null;
}

/**
 * Keeps the entitlement read fresh for the whole session (COS-4956). Renders nothing — mount once
 * inside BusinessOwnerRoutes. The subscription, and the Pusher connection it opens, exist only while
 * `entitlements-phase-1` is on and the session has a business.
 */
export function EntitlementsUpdates(): React.JSX.Element | null {
	const { entitlementsPhase1: isEntitlementsPhase1Enabled } = useFlags<LDFlags>();
	const businessId = useSelector((state: GlobalState) => state.session.business?.id);

	return isEntitlementsPhase1Enabled && businessId ? (
		<EntitlementsSubscription businessId={businessId} />
	) : null;
}
